// extracted by css-extract-rspack-plugin
export default {"dateHighlight":"date-highlight--Sz1YEyawsYUBor0H"};